import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GraphsComponent } from './graphs.component';
import { MaterialModule } from "src/app/shared/material/material.module";
import { ExpansionPanelModule } from "src/app/shared/components/expansion-panel/expansion-panel.module";
import { CustomDropdownModule } from "src/app/shared/components/custom-dropdown/custom-dropdown.module";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomCheckboxdropdownModule } from "src/app/shared/components/custom-checkboxdropdown/custom-checkboxdropdown.module";
import { GaugeChartModule } from "src/app/shared/components/gauge-chart/gauge-chart.module";
import { GraphsRoutingModule } from './gaphs-routing.module';



@NgModule({
  declarations: [
    GraphsComponent,
  
  ],
  imports: [
    CommonModule,
    MaterialModule,
    ExpansionPanelModule,
    CustomDropdownModule,
    FormsModule,
    CustomCheckboxdropdownModule,
    ReactiveFormsModule,
    FormsModule,
    GaugeChartModule,
    GraphsRoutingModule
],
exports:[
  GraphsComponent
]
})
export class GraphsModule { }
